import React, { useEffect, useState } from "react";
import "./RingDeviceModal.css";
import { Modal } from "react-bootstrap";
import { CrossIconBtn } from "assets/SVGs/SVGs";
import CustomButton from "components/widgets/custom-button/CustomButton";
import { titles } from "constants/titles";

const RingDeviceModal = ({ show, setShow, onClick, selectedDeviceDetails }) => {
  const [ringingDevice, setRingingDevice] = useState(false);

  useEffect(() => {
    if (ringingDevice) {
      setTimeout(() => {
        setRingingDevice(false);
        setShow(false);
      }, [5000]);
    }
  }, [ringingDevice]);

  const handleClose = () => {
    if (!ringingDevice) {
      setShow(false);
    }
  };

  return (
    <Modal
      backdrop="true"
      aria-labelledby="contained-modal-title-vcenter"
      className="rdm_container"
      show={show}
      onHide={handleClose}
    >
      <Modal.Body className="rdm_body">
        <div className="rdm_header">
          <CrossIconBtn
            className="rdm_cross_icon"
            onClick={() => setShow(!show)}
          />
        </div>
        <div className="rdm_content">
          {!ringingDevice ? (
            <>
              <div className="rdm_device_container">
                <img
                  src={selectedDeviceDetails?.image_url || ""}
                  className="rdm_device_image"
                  alt="Device"
                />
              </div>
              <h3 className="rdm_title">{titles?.ring_device}</h3>
              <p className="rdm_description">
                {titles?.ring_device_modal_desc}
              </p>
              <CustomButton
                text={titles?.ring_device}
                width="100%"
                className="rdm_ring_button"
                onClick={() => {
                  onClick();
                  setRingingDevice(true);
                }}
              />
            </>
          ) : (
            <>
              <div className="rdm_progress_container">
                <svg
                  className="rdm_progress_circle"
                  width="140"
                  height="140"
                  viewBox="0 0 140 140"
                >
                  <circle className="rdm_circle_background" cx="70" cy="70" r="65" />
                  <circle className="rdm_circle_progress" cx="70" cy="70" r="65" />
                </svg>
              </div>
              <h3 className="rdm_title">{titles?.ring_device}</h3>
              <p className="rdm_description">
                {titles?.ring_device_modal_desc}
              </p>
            </>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default RingDeviceModal;
